export default __webpack_public_path__ + "static/media/6.488fae08.png";